// Maps runtime app settings to ENV. Each key is a live getter so a read always
// reflects the current appSettings cache, regardless of when loadAppSettings() resolves.
import { getAppSettings } from './appSettings';

const ENV = {};

for (const key of [
  'VUE_APP_ENDPOINT',
  'VUE_APP_SHIPBOB_AUTHENTICATE',
  'VUE_APP_SHIPBOB_SITE',
  'VUE_APP_SHIPBOB_LINK',
  'VUE_APP_AUTH_AUTHORITY',
  'VUE_APP_CLIENT_ID',
  'VUE_APP_CLIENT_SCOPE',
  'MFE_ROOT_ROUTE',
  'SHIPBOB_UI_URL',
]) {
  Object.defineProperty(ENV, key, {
    enumerable: true,
    get: () => getAppSettings()[key],
  });
}

export { ENV };
